import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  complianceData: null,
  rejectionData: null,
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    fetchComplianceRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchComplianceSuccess: (state, action) => {
      state.loading = false;
      state.complianceData = action.payload;
    },
    fetchComplianceFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchRejectionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchRejectionSuccess: (state, action) => {
      state.loading = false;
      state.rejectionData = action.payload;
    },
    fetchRejectionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchComplianceRequest,
  fetchComplianceSuccess,
  fetchComplianceFailure,
  fetchRejectionRequest,
  fetchRejectionSuccess,
  fetchRejectionFailure,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
